import React, { useEffect, Fragment } from 'react';
import Store from 'state/Store';
import ThirdPartyWebsiteModal from 'components/shared/Modal/ThirdPartyWebsiteModal';
import {
  showThirdPartyModal,
  targetURL
} from 'state/thirdParty/ThirdPartyModalActions';

const externalWhiteList = ['turbotax'];

/* Link Wrapper component that shows third party website modal if link is white listed external URL */
const LinkWrapper = ({ title, url, className, target }) => {
  useEffect(() => {
    Store.dispatch(targetURL(url));
  });

  const isExternal = externalWhiteList.some((str) => url.indexOf(str) !== -1);

  return isExternal ? (
    <Fragment>
      <ThirdPartyWebsiteModal />
      <button
        onClick={() => Store.dispatch(showThirdPartyModal(true))}
        className={className}
      >
        {title}
      </button>
    </Fragment>
  ) : (
    <a href={url} target={target} className={className}>
      {title}
    </a>
  );
};

LinkWrapper.defaultProps = {
  target: '_self',
  url: null
};

export default LinkWrapper;
